<template>
  <div>
      <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>协议管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 搜索与添加区域 -->
      <el-collapse accordion>
        <el-collapse-item>
          <template slot="title">
            <el-row :gutter="20">
              <el-col :span="8">
                <el-input placeholder="请输入标题" v-model.trim="queryInfoparams.params.title" clearable @change="search"></el-input>
              </el-col>
              <el-col :span="8">
                <el-button class="collapseBtn" plain icon="el-icon-search" @click="search">查询</el-button>
              </el-col>
            </el-row>
          </template>
        </el-collapse-item>
      </el-collapse>
      <el-row type="flex" justify="end">
        <el-col class="searchBtns" :span="6">
          <el-button-group>
            <el-button plain size="small" icon="el-icon-plus"  @click="openAddDialog">自定义协议</el-button>
          </el-button-group>
        </el-col>
      </el-row>
      <!-- 协议列表区域 -->
      <el-table :data="agreementList" border stripe>
        <el-table-column type="index" label="No."></el-table-column>
        <el-table-column label="标题" sortable prop="title"></el-table-column>
        <el-table-column label="协议类型" sortable prop="type"></el-table-column>
        <el-table-column label="创建时间" prop="createdTime"></el-table-column>
        <el-table-column label="更新时间" prop="updatedTime"></el-table-column>
        <el-table-column label="协议状态" sortable>
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === '0'" type="success">启用</el-tag>
            <el-tag v-else-if="scope.row.status === '1'" type="info">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180px">
          <template slot-scope="scope">
            <!-- 修改按钮 -->
            <el-link icon="el-icon-edit" @click="showEditDialog(scope.row.id)">编辑</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link
              type="text"
              size="small"
              v-if="scope.row.status === '1'"
              @click="agreementEnable(scope.row.id)"
            >启用</el-link>
            <el-link
              type="text"
              size="small"
              v-if="scope.row.status === '0'"
              @click="agreementDisable(scope.row.id)"
            >禁用</el-link>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfoparams.current"
        :page-sizes="[10, 50, 100, 200]"
        :page-size="queryInfoparams.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
    <!-- 修改协议s的对话框  此处可优化合并为一个对话框-->
    <el-dialog title="编辑协议" :visible.sync="editDialogVisible" width="50%" @close="editDialogClosed">
      <el-form :model="edorForm" :rules="addFormRules" ref="editFormRef" label-width="70px">
        <el-form-item label="标题" prop="title" label-width="100px">
          <el-input v-model="edorForm.title"></el-input>
        </el-form-item>
        <el-form-item label="协议内容" label-width="100px" prop="context">
          <editor
            v-model="edorForm.context"
            class="set-wang"
            :isClear="isClear"
            @change="changeEditor"
          ></editor>
        </el-form-item>
        <el-form-item label="协议类型" prop="type" label-width="100px">
          <el-select v-model="edorForm.type" placeholder="协议类型">
            <el-option label="注册协议" value="register"></el-option>
            <el-option label="登录协议" value="login"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editAgreementInfo">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 添加协议的对话框 -->
    <el-dialog title="添加协议" :visible.sync="addDialogVisible" width="50%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="70px">
        <el-form-item label="标题" label-width="90px" prop="title">
          <el-input v-model="addForm.title"></el-input>
        </el-form-item>
        <el-form-item label="内容" label-width="90px" prop="context">
          <editor
            v-model="addForm.context"
            class="set-wang"
            :isClear="isClear"
            @change="changeEditor"
          ></editor>
        </el-form-item>
        <el-form-item label="协议类型" label-width="90px"  prop="type">
          <el-select v-model="addForm.type" placeholder="协议类型" >
            <el-option label="注册协议" value="register"></el-option>
            <el-option label="登录协议" value="login"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="协议状态" prop="status" label-width="90px">
          <el-select v-model="addForm.status" placeholder="协议状态">
            <el-option label="启用" value="0"></el-option>
            <el-option label="禁用" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAgreement">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Editor from '@/components/editor/Editor'
export default {
  components: {
    Editor,
  },
  data() {
    return {
      editor: null,
      editorData: '',
      // 获取用户列表的参数对象
      queryInfoparams: {
        // 当前页码
        current: 0,
        // 查询参数
        params: {},
        // 当前每页显示多少条数据
        size: 10,
        // 排序字段
        sortField: '',
        // ASC  DESC 顺序
        sortOrder: '',
      },
      total: 0,
      //返回协议列表
      agreementList: [],
      addDialogVisible: false,
      // 控制编辑协议对话框的显示与隐藏
      editDialogVisible: false,
      addForm: {
        title: '',
        context: '',
        type: '',
        status: '',
      },
      edorForm: {},
      // 添加表单的验证规则对象
      addFormRules: {
        status: [{required: true, message: '协议类型不能为空', trigger: 'blur' }],
        type: [{ required: true, message: '协议类型不能为空', trigger: 'blur' }],
        title: [{ required: true, message: '标题不能为空', trigger: 'blur' }],
        context: [
          { required: true, message: '请输入协议内容', trigger: 'blur' },
          {
            trigger: 'blur',
          },
        ],
        setRoleDialogVisible: false,
        // 需要协议信息信息
        AgreementInfo: {},
      },
      wangContent: '',
      isClear: false,
    }
  },
  methods: {
    // 打开新增协议 弹窗
    openAddDialog() {
      this.addDialogVisible = true
    },
    getEditorData() {
      // 通过代码获取编辑器内容
      let data = this.editor.txt.html()
      console.log('data', data)
      alert(data)
    },
    selectAgreementByTitle(title) {
      // let res = await getAgreementByTitle(title)
      this.$post('agreement/selectAgreementByTitle', title).then(
        ({ data: res }) => {
          console.log(res)
        }
      )
    },
    async agreementEnable(id) {
      this.$confirm('将该协议启用, 是否确定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$get(`agreement/agreementEnable/${id}`).then(({ data: res }) => {
            console.log(res)
            if (res.code === 500) {
              this.$message.error('该类型已经存在已启用的协议，不能进行启用操作')
            }
            this.search()
          })
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '已取消',
          })
        })
    },
    async agreementDisable(id) {
      this.$confirm('将该协议停用, 是否确定?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$get(`agreement/agreementDisable/${id}`).then(
            ({ data: res }) => {
              console.log(res)
              console.log('前端')
              this.search()
            }
          )
        })
        .catch(() => {
          this.$message({
            type: 'error',
            message: '已取消',
          })
        })
    },
    search(){
        this.queryInfoparams.current=0
         this.getAgreements()
    },
    async getAgreements() {
      this.$post('/agreement/pageQuery', this.queryInfoparams).then(
        ({ data: res }) => {
          this.agreementList = res.records
          this.total = res.total
          // console.log('协议', this.agreementList)
        }
      )
    },
    async getAgreementById(id) {
      this.$get(`agreement/agreementDisable/${id}`).then(({ data: res }) => {
        console.log(res)
        let resAgre = res.data
      })
    },
    async getAgreementById(id) {
      this.$get(`agreement/agreementDisable/${id}`).then(({ data: res }) => {
        console.log(res)
        let resAgre = res.data
      })
    },
    // 监听pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfoparams.size = newSize
      this.getAgreements()
    },
    // 监听页码值 改变的事件
    handleCurrentChange(newPage) {
      this.queryInfoparams.current = newPage
      this.getAgreements()
    },

    // 监听添加协议对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields()
    },
    // 展示编辑协议的对话框
    async showEditDialog(id) {
      // console.log(id)
      this.$get(`agreement/getAgreement/${id}`).then(({ data: res }) => {
        this.edorForm = res.data
         this.editDialogVisible = true
      })
    },
    // 监听修改协议对话框的关闭事件
    editDialogClosed() {
      this.edorForm = {}
      this.$refs.editFormRef.resetFields()
    },
    // 点击按钮 添加新协议
    async addAgreement() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        this.$postFile('agreement/save', this.addForm).then(({ data: res }) => {
          console.log(res.msg)
          if (res.code !== 200 && res.msg !== "exits") {
            return this.$message.error('添加协议失败')
          }
          else if (res.msg  === "exits") {
            return this.$message.error("当前协议已经存在启用记录，请停用后新增")
          }
          this.$message.success('添加协议成功')
          // 隐藏添加协议的对话框
          this.addDialogVisible = false
          // 刷新户协议数据
          this.search()
        })
      })
    },

    // 修改协议信息并提交
    async editAgreementInfo() {
      console.log("文本",this.edorForm)
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        this.$postFile('agreement/update', this.edorForm).then(({ data: res }) => {
          if (res.code !== 200) {
            return this.$message.error('编辑协议信息失败')
          }
          // 刷新数据列表
          this.search()
          this.$message.success('编辑协议信息成功')
          // 关闭对话框
          this.editDialogVisible = false
          //清空数据
          this.edorForm = {}
        })
      })
    },
    changeEditor(data) {
      this.edorForm.context = data
    },
  },
  created() {
    this.search()
  },
}
</script>
<style lang="less" scoped>
.el-select {
  width: 100%;
}
/deep/.el-collapse-item__content {
  display: flex;
  justify-content: space-between;
}
.collapseBtn {
  height: 40px;
}
.searchBtns {
  flex: 1;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-collapse-item__wrap {
  border: none !important;
}
/deep/.el-collapse-item__header {
  border: none !important;
}
.el-row {
  flex: 1;
}
.home {
  width: 1200px;
  margin: auto;
  position: relative;
  .btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px 10px;
    cursor: pointer;
  }
  h3 {
    margin: 30px 0 15px;
  }
}
</style>